/**
 * academy-ui/src/template/sections/canvas/canvasThemeResolver.js
 *
 * THIN RE-EXPORT ADAPTER over the synced shared engine. This module used to
 * hand-reimplement the editor's Theme_Cascade resolver (the `THEMEABLE` list, the
 * `defines` semantics, and the `resolveEffective` / `resolveItemStyle` precedence) as a
 * byte-for-byte COPY of the builder's `themeEngine.js`. That hand-copy drifted from the
 * builder and is now eliminated: the reader consumes the SAME resolver as the builder
 * through the synced mirror at `canvas-engine/item-contract/`, so the published page
 * (`academy-ui`) and the Canva-style Editor (`admin-console-ui`) can never disagree
 * about an effective theme value (Req 11.5, 11.6).
 *
 * The shared resolver (`itemThemeResolver`) is an improvement over the previous reader
 * copy: its `resolveItemStyle` handles BOTH the in-process `section.theme` shape AND the
 * persisted `section.canvas.theme` shape, and it applies `DEFAULT_TEMPLATE_THEME` as the
 * implicit base when `template.theme` is missing/empty/partial — guaranteeing a value
 * for every themeable property.
 *
 * ISOLATION: the mirror is generated by `scripts/sync-canvas-engine.js` from
 * `admin-console-ui/src/canvas-engine/` and imported via the reader app's jsconfig
 * `baseUrl=src`. No file in `academy-ui` imports source from `admin-console-ui`.
 *
 * Every export name the old file provided is preserved (THEMEABLE, resolveEffective,
 * resolveItemStyle) so `CanvasSectionReader` and any other importer keep working;
 * `seedSectionTheme` and `withoutOverride` are also surfaced from the shared engine.
 *
 * Requirements: 11.5 (builder and reader resolve themes via the same resolver),
 * 11.6 (resolver operates on exactly the themeable key set).
 */

// Theme-cascade resolver: the single shared source of truth (builder + reader).
export {
  resolveEffective,
  resolveItemStyle,
  seedSectionTheme,
  withoutOverride,
} from 'canvas-engine/item-contract/itemThemeResolver';

// The themeable style properties resolved through the cascade.
export { THEMEABLE } from 'canvas-engine/item-contract/itemConstants';
